import dayjs from 'dayjs';
import { t } from 'i18next';

import { DataTableColumn } from '~components/DataTable/dataTableColumn';
import { TelematicsVehicle } from '~hooks/useTelematicsVehicles/models';

import { MAPPING_COLUMN_MIN_WIDTH_PX } from './QuickBooksMapping/mappingColumnWidth';
import { TelematicsVehicleEquipmentSelector } from './TelematicsVehicleEquipmentSelector';

export type RemoteVehicleRow = {
  id: string;
  remoteVehicle: TelematicsVehicle;
};

export const equipmentIDDef: DataTableColumn<RemoteVehicleRow> = {
  field: 'fleetTruckName',
  headerName: t(
    'administration.integration.remote_vehicles_table.telematics_equipment_id',
  ),
  valueGetter: (row) => row.remoteVehicle.remoteVehicleExternalId ?? '—',
};

export const commandAlkonVehicleNumberDef: DataTableColumn<RemoteVehicleRow> = {
  field: 'commandAlkonVehicleNumber',
  headerName: t(
    'administration.integration.remote_vehicles_table.command_alkon_vehicle_number',
  ),
  valueGetter: (row) => row.remoteVehicle.remoteVehicleExternalKey ?? '—',
};

export const equipmentNameDef: DataTableColumn<RemoteVehicleRow> = {
  field: 'equipmentName',
  headerName: t(
    'administration.integration.remote_vehicles_table.telematics_equipment_name',
  ),
  valueGetter: (row) => row.remoteVehicle.remoteVehicleExternalName,
};

export const licensePlateDef: DataTableColumn<RemoteVehicleRow> = {
  field: 'licensePlate',
  headerName: t('administration.integration.remote_vehicles_table.license_plate'),
  valueGetter: (row) => row.remoteVehicle.remoteVehicleExternalLicensePlateNumber,
};

export const vinDef: DataTableColumn<RemoteVehicleRow> = {
  field: 'vin',
  headerName: t('administration.integration.remote_vehicles_table.vin'),
  valueGetter: (row) => row.remoteVehicle.remoteVehicleExternalVin,
};

export const modelDef: DataTableColumn<RemoteVehicleRow> = {
  field: 'model',
  headerName: t('administration.integration.remote_vehicles_table.model'),
  valueGetter: (row) => row.remoteVehicle.remoteVehicleExternalModel ?? '—',
};

export const lastSyncedDef: DataTableColumn<RemoteVehicleRow> = {
  field: 'lastSynced',
  headerName: t('administration.integration.remote_vehicles_table.last_synced'),
  valueGetter: (row) =>
    dayjs.tz(row.remoteVehicle.updatedAt).format('MMM D, YYYY h:mm A'),
};

export const buildEquipmentMappingDef = (
  onEquipmentSaved: () => void,
): DataTableColumn<RemoteVehicleRow> => ({
  field: 'equipmentID',
  minWidth: MAPPING_COLUMN_MIN_WIDTH_PX,
  headerName: t(
    'administration.integration.remote_vehicles_table.tread_equipment_mapping',
  ),
  renderCell: (row) => (
    <TelematicsVehicleEquipmentSelector
      onEquipmentSaved={onEquipmentSaved}
      remoteVehicle={row.remoteVehicle}
    />
  ),
});
